// READ MORE/LESS FUNCTIONALITY
document.addEventListener('DOMContentLoaded', function() {
  var content = document.querySelector('.js-read-more-content');
  var contentIntro = document.querySelector('.read-more-content__intro');
  var contentFull = document.querySelector('.js-read-more-content__crop');
  var contentWordLimit = content.getAttribute('[data-word-count-limit]');
  var contentFullText = contentFull.textContent;
  var contentFullWordCount = contentFullText.split(' ').length;

  if (contentFullWordCount > contentWordLimit) {
    var readMoreButton = document.createElement('button');
    readMoreButton.className = 'read-more-button js-read-more-button';
    readMoreButton.textContent = 'Read More';
    content.parentNode.insertBefore(readMoreButton, content.nextSibling);

    // Show/hide the content when the button is clicked
    readMoreButton.addEventListener('click', function () {
      if (contentFull.style.display === 'none') {
        contentFull.style.display = 'block';
        readMoreButton.textContent = 'Read Less';
        contentIntro.style.display = 'none';
      } else {
        contentFull.style.display = 'none';
        readMoreButton.textContent = 'Read More';
        contentIntro.style.display = 'block';
      }
    });
  }
});
